<template>
    <el-dialog v-model="dialogShow" width="360px" title="意见反馈" center @close="closeEvent">
        <div class="login-container">
            <div class="login-form">
                <el-form ref="loginRef" :model="formData" :rules="formRules">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="opinionType">
                                <el-select v-model="formData.opinionType" placeholder="选择反馈的问题类型">
                                    <el-option :label="item.dicItemName" :value="item.dicItemCode" v-for="item in opinionTypeList" :key="item.dicItemCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="opinionContent">
                                <el-input type="textarea" :rows="4" v-model="formData.opinionContent" placeholder="请详细描述您要反馈的内容"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="correct-tip">
                        <span>上传图片(最多5张)</span>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <el-upload class="upload-box" v-model:file-list="fileList" action="#" :max="5" list-type="picture-card" :http-request="httpRequest" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                                    <div class="upload-inner">
                                        <div>
                                            <el-icon size="24">
                                                <Camera />
                                            </el-icon>
                                        </div>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="submitEvent">提交</el-button>
            </div>

            <el-image-viewer v-if="showPreview" :url-list="previewFileArr" show-progress :initial-index="previewIndex" @close="showPreview = false" />
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { uploadImg, delImgApi, addOpinion, getDict } from "@/api/common.js"
import { ref, onMounted, defineProps, defineEmits } from 'vue';
import { ElMessage } from 'element-plus'
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    opinionType: '',
    opinionContent: ''
})
const opinionTypeList = ref([])
const fileList = ref([])
const previewFileArr = ref([])
const fileArr = []
const previewIndex = ref(0)
const showPreview = ref(false)
const emitList = defineEmits(['close'])
const formRules = {
    opinionContent: [
        {
            message: '请填写反馈内容',
            required: true
        }
    ],
    opinionType: [
        {
            message: '请选择问题类型',
            required: true
        }
    ]
}

function submitEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            console.log(formData.value)
            let params = {
                opinionContent: formData.value.opinionContent,
                opinionType: formData.value.opinionType,
                opinionFileIds: fileArr.map(item => {
                    return item.fileId
                }).join(',')
            }
            addOpinion(params).then(res => {
                console.log(res)
                ElMessage.success('提交成功')
                emitList('close')

            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        delImgApi(file.fileId).then(() => {
            ElMessage.success('删除成功')
            fileArr.splice(index, 1)
            previewFileArr.value.splice(index, 1)
        })
    }
}

function getDictList() {
    getDict({
        dicCode: 'dd_opinion_type'
    }).then(res => {
        opinionTypeList.value = res.data || []
    })
}

function closeEvent() {
    emitList('close')
}

onMounted(() => {
    getDictList()
})

</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}
</style>

